export enum DomainFilterType {
    ALL = 0,
    DOMAIN = 1,
    COMPONENT = 2,
    FOCUS_AREAS = 3
}